import React from "react";
import { Helmet } from "react-helmet-async";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Container from "../../common/Container";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Banner from "./components/Banner";
import Image from "../../assets/banner/ai.jpg";
import Form from "./components/Form";
import Map from "./components/Map";

const styles = {
  paperContainer: {
    height: 300,
    backgroundImage: `linear-gradient(rgba(57,72,78,0.5),rgba(57,72,78,0.5)), url(${Image})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
};
const Contact = () => {
  const theme = useTheme();
  return (
    <Box>
      <Helmet>
        <title> Contact Us | The African Innovation and Resilience Fund</title>
      </Helmet>
      <AppBar
        position={"sticky"}
        elevation={0}
        sx={{
          backgroundColor: theme.palette.background.paper,
          padding: "10px 0px",
        }}
      >
        <Container paddingY={{ xs: 1 / 2, sm: 1 / 2 }}>
          <Header />
        </Container>
      </AppBar>
      <Box style={styles.paperContainer}>
        <Container>
          <Banner />
        </Container>
      </Box>
      <Box>
        <Map />
      </Box>
      <Box>
        <Container>
          <Form />
        </Container>
      </Box>
      <Box bgcolor={"#39484E"}>
        <Container>
          <Footer />
        </Container>
      </Box>
    </Box>
  );
};

export default Contact;
